// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4c8dce2d","977":"e0f3e239"}[chunkId] + ".chunk.js";
};